<template>
  <div class="content-body">
    <div class="card bg">
       <div class="card-body">
         <div class="left-header">
           <i class="el-icon-s-custom"></i>
         </div>
         <div class="company-name" v-text="user_info.user_name"></div>
         <div class="balance">
           <div class="left-icon">
             <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                 <title>编组</title>
                 <desc>Created with Sketch.</desc>
                 <g id="页面1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                     <g id="首页--" transform="translate(-381.000000, -146.000000)" fill="#2F88FF">
                         <g id="编组-10" transform="translate(381.000000, 135.000000)">
                             <g id="编组-8" transform="translate(0.000000, 1.000000)">
                                 <g id="编组" transform="translate(0.000000, 10.000000)">
                                     <g id="Group-9-Copy-8" opacity="0.14699">
                                         <circle id="Oval" cx="14" cy="14" r="14"></circle>
                                     </g>
                                     <g id="客储转化率" transform="translate(8.000000, 8.000000)">
                                         <g id="Group">
                                             <path d="M0.0273420048,2.81740105 C0.0273420048,1.36312613 2.7013962,0.184213205 6.00001182,0.184213205 C9.29862743,0.184213205 11.9726816,1.36313733 11.9726816,2.81740105 C11.9726816,4.27167374 9.29862743,5.4505889 6.00001182,5.4505889 C2.7013962,5.4505889 0.0273420048,4.27166477 0.0273420048,2.81740065 Z M0.541083588,5.04541887 C1.47139711,5.96678353 3.56528723,6.60894589 6.00001182,6.60894589 C8.4347364,6.60894589 10.5291878,5.96678353 11.4594953,5.04541887 C11.7893589,5.372395 11.973225,5.73411533 11.973225,6.11568948 C11.973225,7.57001821 9.29919065,8.74887733 6.00001975,8.74887733 C2.7013843,8.74887733 0.0273499375,7.57002718 0.0273499375,6.11568948 C0.0273499375,5.73473408 0.210668324,5.37239276 0.541079622,5.04541887 Z M0.541083588,8.28664139 C1.47139711,9.20738506 3.56528723,9.85016842 6.00001182,9.85016842 C8.4347364,9.85016842 10.5291878,9.20738506 11.4594953,8.28664139 C11.7893589,8.61361752 11.973225,8.97533785 11.973225,9.35629325 C11.973225,10.810622 9.29919065,11.9894811 6.00001975,11.9894811 C2.7013843,11.9894811 0.0273499375,10.8106309 0.0273499375,9.35629325 C0.0273499375,8.97533785 0.210668324,8.61361752 0.541079622,8.28664139 Z" id="形状结合"></path>
                                         </g>
                                     </g>
                                 </g>
                             </g>
                         </g>
                     </g>
                 </g>
              </svg>
           </div>
           <div class="right-content">
             <div class="title">账户余额</div>
             <div class="money" v-text="data.company_balance"></div>
           </div>
         </div>
         <div class="balance">
           <div class="left-icon">
             <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                 <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                 <title>编组 3</title>
                 <desc>Created with Sketch.</desc>
                 <g id="页面1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                     <g id="首页--" transform="translate(-547.000000, -146.000000)">
                         <g id="编组-10" transform="translate(381.000000, 135.000000)">
                             <g id="编组-4" transform="translate(166.000000, 1.000000)">
                                 <g id="编组-3" transform="translate(0.000000, 10.000000)">
                                     <g id="Group-9-Copy-2" fill="#FAAD15" fill-opacity="0.15">
                                         <circle id="Oval" cx="14" cy="14" r="14"></circle>
                                     </g>
                                     <g id="点赞" transform="translate(5.000000, 5.000000)">
                                         <g id="Group" transform="translate(0.047958, 0.211539)">
                                             <g id="编组" transform="translate(0.952042, 0.788461)">
                                                 <rect id="矩形" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="16" height="16"></rect>
                                                 <path d="M11.3411381,2.19129274 C10.3587984,1.63109099 9.21751349,1.31034483 8,1.31034483 C4.31810167,1.31034483 1.33333333,4.24365164 1.33333333,7.86206897 C1.33333333,11.4804863 4.31810167,14.4137931 8,14.4137931 C11.6818983,14.4137931 14.6666667,11.4804863 14.6666667,7.86206897 C14.6666667,6.67381396 14.3447877,5.55944163 13.7820438,4.59856924" id="Oval-36" stroke="#FAAD15" stroke-width="1.33333333" stroke-linecap="round" stroke-linejoin="round"></path>
                                                 <path d="M8.90663126,9.46650258 C9.77101658,7.53748148 10.2010932,6.32962707 10.1968611,5.84293936 C10.190513,5.1129078 9.59355938,4.51595413 8.86352781,4.50960603 C8.13349625,4.50325793 7.54683488,5.08991929 7.55318298,5.81995086 C7.55741505,6.30663857 8.00856448,7.52215581 8.90663126,9.46650258 Z" id="Oval" stroke="#FAAD15" stroke-width="1.33333333" fill="#FAAD15" fill-rule="nonzero" stroke-linejoin="round" transform="translate(8.875012, 6.988029) scale(1, -1) rotate(-45.000000) translate(-8.875012, -6.988029) "></path>
                                             </g>
                                         </g>
                                     </g>
                                 </g>
                             </g>
                         </g>
                     </g>
                 </g>
             </svg>
           </div>
           <div class="right-content">
             <div class="title">今日消耗</div>
             <div class="money" v-text="data.today_pay"></div>
           </div>
         </div>
         <div class="balance">
           <div class="left-icon">
             <svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                 <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                 <title>编组 23</title>
                 <desc>Created with Sketch.</desc>
                 <g id="页面1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                     <g id="首页--" transform="translate(-704.000000, -146.000000)">
                         <g id="编组-10" transform="translate(381.000000, 135.000000)">
                             <g id="分组" transform="translate(323.000000, 0.000000)">
                                 <g id="编组-23" transform="translate(0.596558, 11.571533)">
                                     <path d="M14,28 C21.7319865,28 28,21.7319865 28,14 C28,6.2680135 21.7319865,0 14,0 C6.2680135,0 0,6.2680135 0,14 C0,21.7319865 6.2680135,28 14,28 Z" id="Oval" fill-opacity="0.15" fill="#F45858"></path>
                                     <g id="编组-2" transform="translate(5.403442, 5.428467)">
                                         <rect id="矩形" fill-opacity="0.01" fill="#FFFFFF" x="0.596191406" y="0.409179688" width="16" height="16"></rect>
                                         <g id="编组" transform="translate(1.000000, 2.000000)" stroke="#F45858" stroke-width="1.33333333">
                                             <path d="M2.66666667,3.33333333 L2.66666667,12" id="Path-410" stroke-linecap="round" stroke-linejoin="round"></path>
                                             <path d="M7.59655762,7.66666667 L7.59655762,12" id="Path-411" stroke-linecap="round" stroke-linejoin="round"></path>
                                             <path d="M7.59655762,4.33333333 L7.59655762,1" id="Path-413" stroke-linecap="round" stroke-linejoin="round"></path>
                                             <path d="M12.5965576,1 L12.5965576,8.66666667" id="Path-414" stroke-linecap="round" stroke-linejoin="round"></path>
                                             <path d="M2.66666667,3.66666667 C3.40304633,3.66666667 4,3.069713 4,2.33333333 C4,1.59695367 3.40304633,1 2.66666667,1 C1.930287,1 1.33333333,1.59695367 1.33333333,2.33333333 C1.33333333,3.069713 1.930287,3.66666667 2.66666667,3.66666667 Z" id="Oval-8" fill="#F45858" fill-rule="nonzero"></path>
                                             <path d="M7.59655762,7.66666667 C8.33293728,7.66666667 8.92989095,7.069713 8.92989095,6.33333333 C8.92989095,5.59695367 8.33293728,5 7.59655762,5 C6.86017795,5 6.26322428,5.59695367 6.26322428,6.33333333 C6.26322428,7.069713 6.86017795,7.66666667 7.59655762,7.66666667 Z" id="Oval-8-Copy" fill="#F45858" fill-rule="nonzero"></path>
                                             <path d="M12.5965576,12 C13.3329373,12 13.929891,11.4030463 13.929891,10.6666667 C13.929891,9.930287 13.3329373,9.33333333 12.5965576,9.33333333 C11.860178,9.33333333 11.2632243,9.930287 11.2632243,10.6666667 C11.2632243,11.4030463 11.860178,12 12.5965576,12 Z" id="Oval-8-Copy-2" fill="#F45858" fill-rule="nonzero"></path>
                                         </g>
                                     </g>
                                 </g>
                             </g>
                         </g>
                     </g>
                 </g>
             </svg>
           </div>
           <div class="right-content">
             <div class="title">账户日预算</div>
             <div class="money">{{ showBudgetTitle(data.company_budget) }} <span @click="showBudget"><i class="el-icon-edit"></i></span></div>
           </div>
         </div>
         <div class="right-btn">
           <el-button type="primary" size="small" icon="el-icon-plus" @click="jumpPlan">新建广告</el-button>
         </div>
       </div>
    </div>
    <div class="card card-lists">
      <div class="card-one bg">
        <div class="num blue" v-text="data.action_adv"></div>
        <div class="font">投放中计划</div>
      </div>
      <div class="card-one bg">
        <div class="num red" v-text="data.fre_adv"></div>
        <div class="font">暂停中创意</div>
      </div>
      <div class="card-one bg">
        <div class="num" v-text="data.handle_adv"></div>
        <div class="font">审核中计划</div>
      </div>
      <div class="card-one bg">
        <div class="num">0</div>
        <div class="font">问题计划</div>
      </div>
    </div>

    <div class="amount">
      <div class="left-body bg">
        <div class="top-body">
          <div class="a-title">广告数据</div>
          <div class="condition">
            <el-select v-model="dateType" placeholder="请选择" size="mini" style="width: 100px;" @change="getLine">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="data">
          <div class="line-data">
            <div class="line-one">
              <div class="title">消耗</div>
              <div class="money" v-text="count.pay"></div>
            </div>
            <div class="line-one">
              <div class="title">转换数</div>
              <div class="money" v-text="count.zhs"></div>
            </div>
            <div class="line-one">
              <div class="title">预计转换成本</div>
              <div class="money" v-text="count.zhcb"></div>
            </div>
            <div class="line-one">
              <div class="title">平均展示单价</div>
              <div class="money" v-text="count.pjdjdj"></div>
            </div>
          </div>
          <div class="line-data">
            <div class="line-one">
              <div class="title">线索量</div>
              <div class="money" v-text="count.xsl"></div>
            </div>
            <div class="line-one">
              <div class="title">预计客户量</div>
              <div class="money" v-text="count.khl"></div>
            </div>
            <div class="line-one">
              <div class="title">投放展示量</div>
              <div class="money" v-text="count.ldyfwl"></div>
            </div>
            <div class="line-one">
              <div class="title">落地页访问人数</div>
              <div class="money" v-text="count.ldyfwrs"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-body bg">
        <div class="banner">
          <el-carousel :interval="3000" arrow="always" indicator-position="none" height="196px" style="position: relative;">
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <img :src="item.pic" @click="jumpPage(item.url)" alt="" style="width: 100%; height:100%; cursor: pointer;">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="lists">
          <div class="lists-one" v-for="(item, index) in adv" :key="index">
            <div class="title"><a :href="item.url" target="_blank" v-text="item.title"></a></div>
            <div class="date" v-text="getForm(item.create_at)"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="echarts-records" :style="{width: 'calc(100% - 48px)', height: 'calc(100% - 200px)', padding: '16px 24px', marginTop: '20px', background: '#fff'}"></div>

    <el-dialog title="修改账户预算" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="预算方式">
          <el-radio-group v-model="checked">
            <el-radio-button :label="1">不限预算</el-radio-button>
            <el-radio-button :label="0">指定预算</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定预算" v-show="checked !== 1">
          <el-input v-model="input" placeholder="预算设置0元即暂停"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts';
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      curentComponents: 'PlanView',
      data: [],
      dialogVisible: false,
      input: '',
      checked: 0,
      user_info: [],
      banner: [],
      adv: [],
      options: [{
        value: '1',
        label: '今日'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '本月'
      }],
      dateType: '1',
      count: []
    };
  },
  mounted() {
    this.user_info = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info')) : [];
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      if (res.code === 200) {
        this.data = res.data;
        this.checked = parseFloat(res.data.company_budget) >= 99999999 ? 1 : 0;
        this.input = parseFloat(res.data.company_budget);
        this.$function.hiddenLoading();
        this.banner = res.data.banner;
        this.adv = res.data.adv;
        this.getLine();
      }
    });
  },
  methods: {
    getLine() {
      this.$http.post('/trader/data/getIndexCount', {
        dateType: this.dateType
      }).then(res => {
        if (res.code === 200) {
          this.$function.hiddenLoading();
          // this.pay_money = res.data.pay_money;
          // this.look_num = res.data.look_num;
          // this.read_num = res.data.read_num;

          this.count = res.count;
          // 填充数据表格
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');
          const option = {
            title: {
              text: '数据趋势'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              data: ['曝光', '点击', '支付']
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              boundaryGap: false,
              data: res.chat.name
            }],
            yAxis: [{
              type: 'value'
            }],
            series: [
              {
                name: '支付',
                type: 'line',
                stack: '总量',
                areaStyle: {
                  color: '#C4E7FF'
                },
                data: res.chat.pay
              },
              {
                name: '点击',
                type: 'line',
                stack: '总量',
                areaStyle: {},
                data: res.chat.cpc
              },
              {
                name: '曝光',
                type: 'line',
                stack: '总量',
                label: {
                  normal: {
                    show: true,
                    position: 'top'
                  }
                },
                areaStyle: {},
                data: res.chat.exposure
              }
            ]
          };

          echartsRecords.setOption(option);
        }
      });
    },
    sure() {
      this.$http.post('/trader/index/updateBudget', {
        budget: this.input
      }).then(res => {
        if (res.code === 200) {
          this.data.company_budget = this.input;
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.msg);
        }
        this.dialogVisible = false;
      });
    },
    showBudget() {
      this.checked = parseInt(this.input) === 99999999 ? 1 : 0;
      this.dialogVisible = true;
    },
    showBudgetTitle(val) {
      return parseInt(val) >= 99999999 ? '不限' : val;
    },
    jumpPage(url) {
      window.open(url);
    },
    jumpPlan() {
      this.$emit('jump_plan');
    },
    getForm(time) {
      return this.$function.formatDate(time, 'MM-dd');
    }
  },
  watch: {
    checked(newVal) {
      this.input = parseInt(newVal) ? 99999999 : 0;
    }
  }
};
</script>
<style lang="less" scoped="">
  .card:first-child {
    margin-top: 16px;
  }
  .bg {
    padding: 16px 24px;
    background: #fff;
    webkit-box-shadow: 0 1px 6px 0 rgba(0,0,0,.05);
    box-shadow: 0 1px 6px 0 rgba(0,0,0,.05);
  }
  .card {
    margin-bottom: 16px;
    .card-body {
      display: flex;
      align-items: center;
      height: 72px;
      .left-header {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        font-size: 24px;
        background: #d6d6d6;
        border-radius: 50%;
        i {
          color: #fff;
        }
      }
      .company-name {
        margin-left: 16px;
        display: inline-block;
        width: 154px;
        height: 45px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      .balance {
        height: 76px;
        display: flex;
        align-items: center;
        margin-left: 56px;
        .right-content {
          height: 50px;
          margin-left: 16px;
          .title {
            font-size: 12px;
            margin-bottom: 8px;
            color: #999;
          }
          .money {
            font-size: 20px;
            color: #333;
            font-weight: 700;
            i {
              font-size: 16px;
              color: #999;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
      }
      .right-btn {
        flex: 1;
        text-align: right;
      }
    }

  }

  .card-lists {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .card-one {
      width: 240px;
      height: 57px;
      text-align: center;
      .num {
        font-size: 24px;
        margin-bottom: 5px;
        color: #333;
      }
      .font {
        font-size: 12px;
        color: #333;
      }
      .blue {
        color: #2F88FF;
      }
      .red {
        color: #F45858;
      }
    }
  }

  .amount {
    display: flex;
    justify-content: space-between;
    height: 318px;
    .left-body {
      width: 794px;
      height: 100%;
      padding: 0 0;
      .top-body {
        padding: 16px 24px;
        display: flex;
        justify-content: space-between;
      }
      .data {
        height: 220px;
        padding: 16px 90px;
        .line-data {
          display: flex;
          color: #333;
          height: 86px;
          .line-one {
            width: 25%;
            line-height: 32px;
            .title {
              font-size: 12px;
            }
            .money {
              font-size: 20px;
            }
          }
        }
        .line-data:first-child {
          margin-bottom: 30px;
        }
      }
    }
    .right-body {
      width: 390px;
      padding: 0 0;
      .banner {
        height: 196px;
      }
      .lists {
        padding: 16px 27px 16px 21px;
        height: 122px;
        .lists-one {
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          .title {
            a {
              color: #333;
            }
            a:hover {
              color: #3390FF;
            }
          }
          .date {
            color: #999;
          }
        }
      }
    }
  }


</style>
